import { c as _c } from "react/compiler-runtime";
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { FadeUp } from '@algoacademy/design-system/web/marketing/animation/FadeUp';
import { H2 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import type { CalendarEvent } from '../../../_components/CalendarEvent';
import { WomanOnLadder } from './svg/WomanOnLadder';
type SummarySectionProps = {
  selectedEvent: CalendarEvent | null;
  selectedDay: Date;
};
export function SummarySection(t0) {
  const $ = _c(12);
  const {
    selectedEvent,
    selectedDay
  } = t0;
  let t1;
  if ($[0] !== selectedDay || $[1] !== selectedEvent) {
    t1 = selectedEvent ? `${selectedDay.getDate().toString().padStart(2, "0")}.${(selectedDay.getMonth() + 1).toString().padStart(2, "0")}.${selectedDay.getFullYear()} o ${selectedEvent.startTime.getHours().toString().padStart(2, "0")}:${selectedEvent.startTime.getMinutes().toString().padStart(2, "0")}` : "";
    $[0] = selectedDay;
    $[1] = selectedEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedDateTime = t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <VerticalSpacer size="content" />;
    t3 = <H2>Umówiliśmy spotkanie!</H2>;
    t4 = <P2>Wyślemy do Ciebie wiadomość SMS z potwierdzeniem daty i godziny spotkania.</P2>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== formattedDateTime || $[7] !== selectedEvent) {
    t5 = selectedEvent && <P2>Mentor zadzwoni do Ciebie{" "}<span className="font-semibold text-slate-900">{formattedDateTime}</span>. Do zobaczenia!</P2>;
    $[6] = formattedDateTime;
    $[7] = selectedEvent;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <WomanOnLadder className="max-w-[640px]" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <FadeUp><div className="flex flex-col items-center gap-6 text-center sm:text-left">{t2}{t3}{t4}{t5}{t6}</div></FadeUp>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}